var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2645_37045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "#2B4B8E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2645_37045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4023 8.66485L15.3335 7.68765C15.5102 7.62878 15.6707 7.52964 15.8023 7.39805L17.2023 5.99805",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 7.5625L16.8002 13.9977",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0664 8.10938L15.1948 14.1274",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7999 16.398C17.1181 16.398 17.4234 16.2716 17.6484 16.0466C17.8734 15.8215 17.9999 15.5163 17.9999 15.198C17.9999 14.8798 17.8734 14.5746 17.6484 14.3495C17.4234 14.1245 17.1181 13.998 16.7999 13.998L6.70707 14.8072C6.50448 14.8305 6.31847 14.9304 6.18723 15.0865C6.05599 15.2426 5.98948 15.4429 6.00136 15.6465C6.01323 15.8501 6.10259 16.0414 6.25109 16.1812C6.39958 16.3209 6.59595 16.3985 6.79987 16.398H16.7999Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59766 17.1984V16.3984",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.1984V16.3984",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2645_37045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2645_37045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(5.59766 5.19922)"
  })))));
};
export default __webpack_public_path__ + "static/media/icon-test-type-treadmill.1bdc229a.svg";
export { SvgComponent as ReactComponent };